<template>
  <el-card class="theme-block">
    <div slot="header" v-if="title">
      <span>{{ title }}</span>
    </div>
    <el-form
      :element-loading-text="$t('themeLegalFormLoadingText')"
      :model="data"
      @submit.native.prevent="submit"
      id="updateForm"
      label-position="left"
      ref="data"
      v-loading="loading"
    >
      <el-form-item
        :data-qa="`Content-ThemeForm-Item-${id}`"
        :error="errors.has(item.label) ? errors.first(item.label) : ''"
        :key="id"
        :label="$t(item.label)"
        :label-width="labelWidth"
        :show-message="errors.has(item.label)"
        v-for="(item, id) in data.text"
      >
        <el-input
          :data-qa="`Content-ThemeForm-Input-${id}`"
          :data-vv-as="$t(item.label)"
          :id="id"
          :name="item.label"
          :placeholder="$t(item.placeholder) || ''"
          clearable
          type="text"
          v-if="isText(item.type)"
          v-model="item.model"
          v-validate="item.validate"
        />
        <el-input
          :class="item.class"
          :data-qa="`Content-ThemeForm-Textarea-${id}`"
          :data-vv-as="$t(item.label)"
          :id="id"
          :name="item.label"
          :placeholder="$t(item.placeholder) || ''"
          :rows="20"
          type="textarea"
          v-if="isTextarea(item.type)"
          v-model="item.model"
          v-validate="item.validate"
        />
        <div :data-qa="`Content-ThemeForm-Description-${id}`" class="column-describe" v-if="item.description">
          <i>{{ $t(item.description) }}</i>
        </div>
      </el-form-item>
      <el-form-item class="btn-display-end" size="large">
        <el-button
          :disabled="saving || errors.any()"
          :loading="saving"
          data-qa="Content-ThemeForm-Button-Save"
          native-type="submit"
          type="warning"
        >
          {{ $t('themeLegalButtonSaveText')}}
        </el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
  import main from './ThemeLegal.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './ThemeLegal.scss'
</style>



// WEBPACK FOOTER //
// ThemeLegal.vue?261f32e2